import * as React from "react";
import { BarChart3, MoreVertical, RefreshCw, ScanSearch } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Tooltip } from "@/components/ui/tooltip";

interface Props {
  header: string;
  onAnalyseClick?: () => void;
  onReviewClick?: () => void;
  reviewDisabledReason?: string;
  onRerunClick?: () => void;
}

export const ColumnActionsMenu: React.FC<Props> = ({
  header,
  onAnalyseClick,
  onReviewClick,
  reviewDisabledReason,
  onRerunClick,
}) => {
  const showReviewItem = !!onReviewClick || !!reviewDisabledReason;
  if (!onAnalyseClick && !showReviewItem && !onRerunClick) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label={`Column actions for ${header}`}
          onClick={event => event.stopPropagation()}
          className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded text-gray-400 transition-colors hover:bg-gray-200 hover:text-gray-600"
        >
          <MoreVertical className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onClick={event => event.stopPropagation()}>
        {onAnalyseClick && (
          <DropdownMenuItem onClick={onAnalyseClick}>
            <BarChart3 className="mr-2 h-4 w-4" />
            Analyse column
          </DropdownMenuItem>
        )}
        {showReviewItem &&
          (onReviewClick ? (
            <DropdownMenuItem onClick={onReviewClick}>
              <ScanSearch className="mr-2 h-4 w-4" />
              Review responses
            </DropdownMenuItem>
          ) : (
            <Tooltip text={reviewDisabledReason ?? ""} className="rounded bg-black text-xs text-white">
              <DropdownMenuItem disabled>
                <ScanSearch className="mr-2 h-4 w-4" />
                Review responses
              </DropdownMenuItem>
            </Tooltip>
          ))}
        {onRerunClick && (
          <DropdownMenuItem onClick={onRerunClick}>
            <RefreshCw className="mr-2 h-4 w-4" />
            Re-run column
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
